import React from "react";
class Signin extends React.Component{
    constructor(props){
        super(props)
        this.state={
            simail:"",
            sipass:""
        }
    }
    onMailChange=(event)=>{
        this.setState({simail:event.target.value});
    }
    onPasswordChange=(event)=>{
        this.setState({sipass:event.target.value});
    }

    
  onSubmit=()=>{
        console.log(this.state);
        fetch('https://facedetection-backend-ramsundar07.onrender.com/signin', {
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              email: this.state.simail,
              pass: this.state.sipass
            })
          }).then(response=>(response.json()))
          .then(s=>{if(s.name) {
            this.props.updateUser(s);
            this.props.changeRoute("home");
          }
            else{
              alert("Wrong Credentials");
              this.props.changeRoute("signin");
            }
          });
       
    }
    render(){
        const {changeRoute} = this.props;
    return(
        <article className="br3 ba b--black-10 w-100 w-50-m w-25-l mw8 bw2 shadow-5 center">
        <main className="pa4 black-80">
          <div className="measure">
            <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
              <legend className="f2 fw6 ph0 mh0"><u>Sign In</u></legend>
              <div className="mt3">
                <label className="db fw6 lh-copy f6" htmlFor="email-address">Email</label>
                <input
                  className="pa2 input-reset ba bw1 bg-transparent hover-bg-black hover-white w-100"
                  type="email"
                  name="email-address"
                  id="email-address"
                  onChange={this.onMailChange}
                />
              </div>
              <div className="mv3">
                <label className="db fw6 lh-copy f6" htmlFor="password">Password</label>
                <input
                  className="b pa2 input-reset ba bw1 bg-transparent hover-bg-black hover-white w-100"
                  type="password"
                  name="password"
                  id="password"
                  onChange={this.onPasswordChange}
                />
              </div>
            </fieldset>
            <div className="">
              <input
                onClick={this.onSubmit}
                className="b ph3 pv2 input-reset bw2 ba b--black bg-transparent grow pointer f6 dib"
                type="submit"
                value="Sign in"
              />
            </div>
            <div className="lh-copy mt3">
              <p  onClick={() => changeRoute('reg')} className="f6 link dim black db pointer">Register</p>
            </div>
          </div>
        </main>
      </article>
    )
    }
}

export default Signin;